<template>
    <div class="mywrap">
        <div class="meminfo">
            <Left />
        </div>

<!--        <div class="portpwc" v-if="member===null">-->
<!--            <a href="/login">请登录</a><span>/</span><a href="/register">注册</a>-->
<!--        </div>-->

        <div class="myrht">

            <div class="memberinfo myrhtinfo" v-if="member">
                <div class="title"><span>账户信息</span><i></i></div>
<!--                <div class="img">-->
<!--                    <img :src="member.portrait">-->
<!--                </div>-->
                <div class="item">
                    <div class="name">账号</div>
                    <div class="con">{{member.name_zs}}</div>
                </div>
                <div class="item">
                    <div class="name">昵称</div>
                    <div class="con">{{member.nick}}</div>
                </div>
                <div class="item">
                    <div class="name">金豆</div>
                    <div class="con gold">{{member.gold}}</div>
                </div>
                <div class="item">
                    <div class="name">积分</div>
                    <div class="con">{{member.integral}}</div>
                </div>
                <div class="item">
                    <div class="name">注册</div>
                    <div class="con tme">{{member.create}}</div>
                </div>
                <div class="item">
                    <div class="name">简介</div>
                    <div class="con">{{member.intro}}</div>
                </div>
            </div>

        </div>
    </div>


</template>

<script>
    import Left from "./my/left";
    import defPortrait from "../assets/images/user.png";
    export default {
        name: "my",
        components: {Left},
        data (){
          return {
                init: true,
              member: null,

          }
        },
        watch: {
            // '$store.state.token': {
            //     handler(v) {
            //         if (v === null || v === undefined || v === '')
            //             this.member = null
            //         else
            //             this.getMemInfo()
            //     }
            // },
        },
        activated() {
            this.getMemInfo()
        },
        created() {
        },
        methods: {

            getMemInfo() {
                let that = this
                this.$post(that.$api.memberinfo).then(function (res) {
                    if (res.code === 1){
                        let data = res.data.member
                        if(data.portrait === null)
                            data.portrait = defPortrait
                        else
                            data.portrait = that.$api.imgBaseUrl + data.portrait
                        that.member = data
                        that.init = false
                    }
                })
            },
        }
    }
</script>

<style scoped>
</style>